export const additionalLessonDTOFields = {
    courseName: 'courseName',
    price: 'price',
    paymentType: 'paymentType',
    id: 'id',
    settlementType: 'settlementType',
    configured: 'configured',
    free: 'free',
} as const;
